import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Pricing from "../pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import Classes from "@/pages/Classes";
import SharedClasses from "@/pages/SharedClasses";
import SharedClass from "@/pages/SharedClass";
import { Class } from "@/pages/Class";
import Usage from "@/pages/Usage";
import Billing from "@/pages/Billing";
import RootLayout from "@/layouts/root-layout";
import DashboardLayout from "@/layouts/dashboard-layout";
import PublicLayout from "@/layouts/public-layout";
import { ReportCard } from "@/pages/ReportCard";
import { ReportDefaults } from "@/pages/ReportDefaults";
import NotFound from "@/pages/NotFound";
import { FreeTrialReportCardProgressGr16202307 as ProgressGr16_202307Page } from "@/reports/progress-gr1-6-2023-07/Page";
import { FreeTrialReportCardProgressGr78202307 as ProgressGr78_202307Page } from "@/reports/progress-gr7-8-2023-07/Page";
import { FreeTrialReportCardProvincialGr16202309 as ProvincialGr16_202309Page } from "@/reports/provincial-gr1-6-2023-09/Page";
import { FreeTrialReportCardProvincialGr78202309 as ProvincialGr78_202309Page } from "@/reports/provincial-gr7-8-2023-09/Page";
import { FreeTrialReportCardProvincialGr912202202Sem as ProvincialGr912_202202SemPage } from "@/reports/provincial-gr9-12-2022-02-sem/Page";
import FreeTrialPicker from "@/pages/FreeTrialPicker";
import MySchools from "@/pages/MySchools";
import SchoolCreate from "@/pages/SchoolCreate";
import JoinSchool from "@/pages/JoinSchool";
import SchoolDashboard from "@/pages/SchoolDashboard";
import SchoolMembers from "@/pages/SchoolMembers";
import SchoolSettings from "@/pages/SchoolSettings";
import SchoolClasses from "@/pages/SchoolClasses";
import SchoolClassDetail from "@/pages/SchoolClassDetail";
import ShareRequests from "@/pages/ShareRequests";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <PublicLayout />,
        children: [
          { path: "/", element: <Home /> },
          { path: "/about", element: <About /> },
          { path: "/contact", element: <Contact /> },
          { path: "/pricing", element: <Pricing /> },
          { path: "/free-trial", element: <FreeTrialPicker /> },
          { path: "/pgrc", element: <ProgressGr16_202307Page /> },
          { path: "/pgrc78", element: <ProgressGr78_202307Page /> },
          { path: "/pvrc", element: <ProvincialGr16_202309Page /> },
          { path: "/pvrc78", element: <ProvincialGr78_202309Page /> },
          { path: "/pvrc9to12sem", element: <ProvincialGr912_202202SemPage /> },
        ],
      },
      {
        element: <DashboardLayout />,
        children: [
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/classes", element: <Classes /> },
          { path: "/shared-classes", element: <SharedClasses /> },
          { path: "/shared-classes/:sharedClassId", element: <SharedClass /> },
          { path: "/shared-classes/:sharedClassId/reports/:id", element: <ReportCard /> },
          { path: "/classes/:reportGroupId", element: <Class /> },
          { path: "/classes/:reportGroupId/defaults", element: <ReportDefaults /> },
          { path: "/classes/:reportGroupId/reports/:id", element: <ReportCard /> },
          { path: "/usage", element: <Usage /> },
          { path: "/billing", element: <Billing /> },
          // School routes
          { path: "/schools", element: <MySchools /> },
          { path: "/schools/create", element: <SchoolCreate /> },
          { path: "/schools/join", element: <JoinSchool /> },
          { path: "/schools/:schoolId", element: <SchoolDashboard /> },
          { path: "/schools/:schoolId/members", element: <SchoolMembers /> },
          { path: "/schools/:schoolId/settings", element: <SchoolSettings /> },
          { path: "/schools/:schoolId/classes", element: <SchoolClasses /> },
          { path: "/schools/:schoolId/classes/:classId", element: <SchoolClassDetail /> },
          { path: "/schools/:schoolId/share-requests", element: <ShareRequests /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
